<template>
  <div>
    <v-style v-if="config.colors">
      :root { --share-button-background-color:
      {{ config.shareButton.colors.buttonBackgroundColor }};
      --share-button-text-color:
      {{ config.shareButton.colors.buttonTextColor }};
      --share-button-icon-color:
      {{ config.shareButton.colors.buttonIconColor }} };
    </v-style>
    <p class="my-4">
      Preview
    </p>

    <span class="inline-flex rounded-md shadow-sm">
      <button
        type="button"
        class="whatsappsharebutton"
        :class="config.shareButton.design"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16.074"
          viewBox="0 0 16 16.074"
        >
          <g
            id="Group_63773"
            data-name="Group 63773"
            transform="translate(-426.525 -322.416)"
          >
            <path
              id="Path_12957"
              d="M537.461 442.133a2.6 2.6 0 0 0 .792.121 3.292 3.292 0 0 0 .491-.039 2.106 2.106 0 0 0 1.41-1 1.658 1.658 0 0 0 .1-1.026.694.694 0 0 0-.316-.22l-.105-.052c-.138-.069-1.153-.57-1.349-.642a.417.417 0 0 0-.573.141c-.119.179-.469.594-.611.756-.063.072-.114.11-.289.022-.035-.017-.079-.036-.135-.061a4.916 4.916 0 0 1-1.414-.894 5.756 5.756 0 0 1-1.066-1.328c-.069-.119-.031-.164.068-.263.063-.062.133-.148.2-.231l.1-.118a1.215 1.215 0 0 0 .184-.294l.027-.055a.471.471 0 0 0-.016-.443c-.031-.062-.227-.539-.384-.922l-.216-.524c-.156-.375-.341-.406-.5-.4h-.038c-.125-.006-.269-.007-.381-.007a.826.826 0 0 0-.6.281l-.037.04a2.29 2.29 0 0 0-.677 1.668 3.843 3.843 0 0 0 .821 2.091l.032.045a8.577 8.577 0 0 0 3.356 2.945 11.314 11.314 0 0 0 1.126.409z"
              class="cls-1"
              data-name="Path 12957"
              transform="translate(-101.636 -108.015)"
            />
            <path
              id="Path_12958"
              d="M440.2 324.745a7.945 7.945 0 0 0-12.526 9.544l-1.15 4.2 4.3-1.127a7.946 7.946 0 0 0 9.379-12.617zm-5.622 12.015a6.386 6.386 0 0 1-3.255-.891l-.278-.165-2.32.609.619-2.261-.181-.288a6.4 6.4 0 1 1 5.418 3v.113z"
              class="cls-1"
              data-name="Path 12958"
            />
          </g>
        </svg>
        <span
          class="mb-2"
          v-if="config.shareButton.design === 'buttonWithTextIcon'"
        >
          {{ config.shareButton.label }}
        </span>
      </button>
    </span>
  </div>
</template>

<script>
import Vue from "vue";

Vue.component("v-style", {
  // eslint-disable-next-line
  render: function(createElement) {
    return createElement("style", this.$slots.default);
  }
});

export default {
  name: "WhatsappShareButton",
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
